<template>
  <div class="row mx-0 py-1 mb-3 bg-white shadow">
    <div class="col my-auto fw-bold">{{ user.username }}</div>

    <div class="col-2 my-auto">{{ dateConverter }}</div>

    <div class="col-2 text-end my-auto">
      <button type="button" class="btn btn-danger btn-sm" @click="deleteUserRequest" :disabled="user.id == authStore.user.id || user.username == 'admin'">
        <font-awesome-icon icon="trash" />
      </button>
    </div>
  </div>

  <ConfirmationAlert ref="confirmationAlertRef" @confirm="userStore.deleteUser(user.id)" />
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, PropType, ref } from 'vue';

  import { useUserStore } from '@/stores/userStore';
  import { useAuthStore } from '@/stores/authStore';

  import { User } from '@/models/UserModels';

  import ConfirmationAlert from '@/components/ConfirmationAlert.vue';
  //#endregion

  const { user } = defineProps({
    user: {
      type: Object as PropType<User>,
      required: true,
    },
  });

  const userStore = useUserStore();
  const authStore = useAuthStore();

  const dateConverter = computed(() => {
    const d = new Date(user.adate);
    return d.toLocaleDateString('de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  });

  //#region Confirmation Alert
  const confirmationAlertRef = ref();

  function deleteUserRequest() {
    confirmationAlertRef.value?.showAlert(
      'Benutzer löschen',
      `Möchten Sie den Benutzer "${user.username}" unwiderruflich lösche?`,
      'danger',
      '',
      'danger',
      'text-white'
    );
  }
  //#endregion
</script>
